/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-15T11:07:07.08
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveCardOperationLog,
	getCardOperationLogCreateInit,
	getCardOperationLogEditInit,
	getCardOperationLogView,
	deleteCardOperationLog
} from '@api/rentmanage/CardOperationLog';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getCardOperationLogCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getCardOperationLogCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getCardOperationLogEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getCardOperationLogEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveCardOperationLog({}, CardOperationLog) {
			return new Promise((resolve, reject) => {
				saveCardOperationLog(CardOperationLog)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getCardOperationLogView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getCardOperationLogView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteCardOperationLog({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteCardOperationLog({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
